import { useStudioUnauthenticatedContext } from '../context/StudioContext';
import { useFeatureFlags } from './useFeatureFlags';

/**
 * Backend feature flag name for the catalog. When this flag is present on the user's
 * selected app instance set (app_instance_set_feature_flag), the Catalog page is shown.
 */
export const APP_INSTANCE_SET_FEATURE_FLAG_CATALOG = 'CatalogEnabled';

/**
 * Returns true if the Catalog page should be shown for the current user.
 * - Local storage override: if the "catalogEnabled" feature flag is enabled in
 *   clipsFeatureFlags (localStorage), Catalog is shown regardless of backend.
 * - Backend: if the user's selected app set has the CatalogEnabled flag in
 *   app_instance_set_feature_flag, Catalog is shown.
 * - No apps or no CatalogEnabled flag (and no override) → false.
 */
export function useCatalogEnabled(): boolean {
  const { isEnabled } = useFeatureFlags();
  const context = useStudioUnauthenticatedContext();

  if (isEnabled('catalogEnabled')) {
    return true;
  }

  const selectedAppSet = context?.selectedAppSet;
  if (!selectedAppSet?.featureFlags?.length) {
    return false;
  }

  return selectedAppSet.featureFlags.includes(APP_INSTANCE_SET_FEATURE_FLAG_CATALOG);
}
